import { STYLE_LIST } from '../../../config/dataConfig/FJImageToImageData';
import { useSelector, useDispatch } from 'react-redux';
import {
    setSliceSelectedStyleAction,
    setSliceSelectStyleCategoryAction,
} from '../../../redux/slices/FJSliceImageToImage';
import { useCallback } from 'react';
import FJMobileStyleList from './FJMobileStyleList';
import useLocalStore from '../../../hooks/useLocalStore';

const FJMobileStyleListContainer = () => {
    useLocalStore();
    const selectedStyle = useSelector(state => state.imageToImage.selectedStyle);
    const selectStyleCategory = useSelector(state => state.imageToImage.selectStyleCategory);

    const dispatch = useDispatch();

    const changeStyle = useCallback(
        value => {
            dispatch(setSliceSelectedStyleAction(value));
        },
        [dispatch],
    );
    const setSelectStyleCategory = useCallback(
        value => {
            dispatch(setSliceSelectStyleCategoryAction(value));
        },
        [dispatch],
    );

    return (
        <FJMobileStyleList
            list={STYLE_LIST}
            onChange={changeStyle}
            value={selectedStyle}
            selectStyleCategory={selectStyleCategory}
            setSelectStyleCategory={setSelectStyleCategory}
        />
    );
};

export default FJMobileStyleListContainer;
